'use strict';

export default class UserStatsController 
{
	/*@ngInject*/
	constructor($http, $scope, $stateParams) 
	{
		this.$http = $http;
/*
		$http.post('/api/frontend/results/userstats/1')
		.then(response =>
		{
			//console.log(response.data);
			this.stats = response.data;
		});

		$http.post('/api/frontend/results/driverreport/1')
		.then(response =>
		{
			//console.log(response.data);
			this.report = response.data;
		});
*/
		var data = {
			labels: [
				"Tierra",
				"Moqueta",
				"Asfalto"
			],
			datasets: [
			{
				data: [300, 50, 100],
				backgroundColor: [
					"#FF6384",
					"#36A2EB",
					"#FFCE56"
				],
				hoverBackgroundColor: [
					"#FF6384",
					"#36A2EB",
					"#FFCE56"
				]
			}]
		};

		var options = {};
/*
		var myDoughnutChart = new Chart( document.getElementById("categorieschart"), {
			type: 'doughnut',
			data: data,
			options: options
		});

		var myPieChart = new Chart( document.getElementById("trackschart"), {
			type: 'pie',
			data: data,
			options: options
		});
		
		var myPieChart2 = new Chart( document.getElementById("surfaceschart"), {
			type: 'pie',
			data: data,
			options: options
		});*/
	}
}


// WEBPACK FOOTER //
// ./client/app/frontend/results/userstats.controller.js